// src/components/Inv-Tracker/index.jsx
// ============================================================================
// BLOCK ITR.PAGE.001 — Inventory Tracker page entry
// ----------------------------------------------------------------------------
// PURPOSE
// - Keeps page-level title setup and outer padding lightweight.
// - Delegates feature behavior to InvTracker.jsx.
// ============================================================================

import React from 'react';

import Box from '@mui/material/Box';

import InvTracker from './InvTracker.jsx';

export const PAGE_PERMISSION_KEY = 'inv-tracker';

export default function InvTrackerPage() {
  React.useEffect(() => {
    document.title = 'Inventory Tracker';
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <InvTracker />
    </Box>
  );
}
